import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import { CLASS_SETTINGS_MAP_KEYS } from '@/utils/constants';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';

@Component({
    name: 'class-settings',
    components: {
        'material-icons': GoogleMaterialIcon,
    },
})

export default class ClassSettings extends Vue {
    private tenantSettings: any = [];
    private tenantkeyDefinition: any = CLASS_SETTINGS_MAP_KEYS;
    private selectedConfig: any = null;
    private activeComponent: string = 'tx-loader';

    private created() {
        this.$store.dispatch('tenantStore/fetchTenantSettings').then(() => {
            this.tenantSettings = this.$store.state.tenantStore.tenantSettings;
            // console.log('this.tenantkeyDefinition', this.tenantSettings);
            this.onSelectSettings(this.tenantkeyDefinition.can_impersonate_student, 'can_impersonate_student');
        });
    }

    // -------------------------------------------------------------------------------
    // Actions

    private onSelectSettings(setting: any, value: string) {
        setting.tenantKey = value;
        this.activeComponent = setting.key;
        const existingKey = this.tenantSettings.find((item: any) => item.key === value) || {};
        setting.tenantConfig = existingKey;
        this.selectedConfig = setting;
    }

    // --------------------------------------------------------------------------------
    // Methods

    private onChangeConfig(config: any) {
        const payload = {
            tenant_key: this.selectedConfig.tenantKey,
            value: (typeof config === 'object' ? JSON.stringify(config) : config),
        };
    }

    private diabledItem(item: any) {
        if (item.key === 'nav-class-setup' || item.key === 'cm-completion-score') {
            const framworkData = this.tenantSettings.find((setting: any) => setting.key === 'tx_fw_prefs');
            return framworkData ? false : true;
        }
    }
}
